import React from 'react';
import { Grid2, TextField } from '@mui/material';

function LinkedInForm({ values, setFieldValue }) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label="LinkedIn Partner ID"
                    value={values.settings?.trackingId || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            trackingId: ev.target.value,
                        })
                    }
                    placeholder="1234567"
                    helperText="Enter your LinkedIn Insight Tag Partner ID"
                />
            </Grid2>
        </>
    );
}

export default LinkedInForm;
